<template>
  <div>
    <div v-if="totalResponsible">
      <div v-if="responsible.responsible.length > 0" class="grid_responsible_inner fw500">
        <div class="cell">
          {{ responsible.responsible.length > 0 ? responsible.responsible[0].responsible_user_first_name + ' ' + responsible.responsible[0].responsible_user_last_name : '—' }}
        </div>
        <div class="cell">
          {{  responsible.responsible.length > 0 ? $formatCurrency(responsible.responsible[0].project_responsible_salary_sum) + ' €' : '—' }}
        </div>
        <div class="cell">
          {{ responsible.responsible.length > 0 ? $formatCurrency(responsible.responsible[0].project_responsible_salary_sum_approved) + ' €' : '—' }}
        </div>
      </div>
    </div>
    <div v-else>
      <div v-for="(work, w) in works" :key="'workTypes' + w" class="grid fw500">
        <div class="cell">{{ w + 1 + positionPlus }}</div>
        <div class="cell">{{ projectName }}</div>
        <div :class="responsibleTotalShow ? 'grid_inner' : 'grid_responsible_total_inner'">
          <div class="cell">
            {{
              work.is_hourly === 1
                ? $formatTime(work['employee_report'])
                : formatNumber(work['employee_report']) + ' ' + work.measure
            }}
          </div>
          <div class="cell">
            {{
              work['approved_report'] > 0
                ? work.is_hourly === 1
                  ? $formatTime(work['approved_report'])
                  : formatNumber(work['approved_report']) + ' ' + work.measure
                : ''
            }}
          </div>
          <div class="cell">
            {{
              work['paid_report'] > 0
                ? work.is_hourly === 1
                  ? $formatTime(work['paid_report'])
                  : formatNumber(work['paid_report']) + ' ' + work.measure
                : ''
            }}
          </div>
          <div class="cell">
            {{ work.salary ? $formatCurrency(work.salary) + ' €/' + work.measure : '—' }}
          </div>
          <div class="cell">
            {{ work['salary_sum'] ? $formatCurrency(work['salary_sum']) + ' €' : '—' }}
          </div>
          <template v-if="responsibleTotalShow">
            <div class="cell responsibleCell">
              {{ '—' }}
            </div>
            <div class="cell responsibleCell">
              {{ '—' }}
            </div>
            <div class="cell responsibleCell">
              {{ '—' }}
            </div>
          </template>
          <div class="cell">{{ work.name }}</div>
        </div>
      </div>
      <template v-if="extras.length > 0">
        <div class="grid fw500">
          <div class="cell">{{ works.length + 1 + positionPlus }}</div>
          <div class="cell">{{ projectName }}</div>
          <div :class="responsibleTotalShow ? 'grid_inner' : 'grid_responsible_total_inner'">
            <div class="cell">
              {{ $formatTime(getSumByField(extras, 'employee_report')) }}
            </div>
            <div class="cell">
              {{
                getSumByField(extras, 'approved_report') > 0
                  ? $formatTime(getSumByField(extras, 'approved_report'))
                  : ''
              }}
            </div>
            <div class="cell">
              {{
                getSumByField(extras, 'paid_report') > 0
                  ? $formatTime(getSumByField(extras, 'paid_report'))
                  : ''
              }}
            </div>
            <div class="cell">
              {{ '—' }}
            </div>
            <div class="cell">
              {{
                extras && getSumByField(extras, 'salary_sum') > 0 ? $formatCurrency(getSumByField(extras, 'salary_sum')) + ' €' : '—'
              }}
            </div>
            <template v-if="responsibleTotalShow">
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
            </template>
            <div class="cell">{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</div>
          </div>
        </div>
        <div v-for="(extra, e) in extras" :key="'extras' + e" class="grid">
          <div class="cell">{{ works.length + 1 + positionPlus }}.{{ e + 1 }}</div>
          <div class="cell">{{ projectName }}</div>
          <div :class="responsibleTotalShow ? 'grid_inner' : 'grid_responsible_total_inner'">
            <div class="cell">{{ $formatTime(extra['employee_report']) }}</div>
            <div class="cell">
              {{ extra['approved_report'] > 0 ? $formatTime(extra['approved_report']) : '' }}
            </div>
            <div class="cell">
              {{ extra['paid_report'] > 0 ? $formatTime(extra['paid_report']) : '' }}
            </div>
            <div class="cell">
              {{ extra.salary ? $formatCurrency(extra.salary) + ' €/' + localStorage.translations.pages.common.measure.hours_min : '—' }}
            </div>
            <div class="cell">
              {{ extra['salary_sum'] ? $formatCurrency(extra['salary_sum']) + ' €' : '—' }}
            </div>
            <template v-if="responsibleTotalShow">
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
              <div class="cell responsibleCell">
                {{ '—' }}
              </div>
            </template>
            <div class="cell">{{ extra.name }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinanceSalarySliceShowTableTotal",
  props: {
    projectName: {
      type: String,
      default: ''
    },
    positionPlus: {
      type: Number,
      default: 0
    },
    works: {
      type: Array,
      default: () => {
        return []
      },
    },
    extras: {
      type: Array,
      default: () => {
        return []
      },
    },
    totalResponsible: Boolean,
    responsibleTotalShow: {
      type: Boolean,
      default: true,
    },
    responsible: {
      type: [Array, Object],
      default: () => {
        return []
      },
    },
  },
  methods: {
    getSumByField(items, field) {
      return Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
    },
    formatNumber(num) {
      return Math.round(num * 100) / 100
    },
  }
}
</script>
